import { render } from "./FormBuilderView.vue?vue&type=template&id=7c3427f2&scoped=true&ts=true"
import script from "./FormBuilderView.vue?vue&type=script&lang=ts"
export * from "./FormBuilderView.vue?vue&type=script&lang=ts"

import "./FormBuilderView.vue?vue&type=style&index=0&id=7c3427f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3427f2"]])

export default __exports__